import Box from '@enlighten/design-system/dist/Box';
import Chip from '@enlighten/design-system/dist/Chip';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import Image, { StaticImageData } from 'next/image';

export interface Section3CardTag {
	region: string;
	details: React.ReactNode;
}

export interface Section3CardProps {
	title: string;
	map: StaticImageData;
	tags: Section3CardTag[];
}

const Section3Card: React.FC<Section3CardProps> = ({ title, map, tags }) => {
	return (
		<Stack
			justifyContent="space-between"
			gap="24px"
			sx={{
				backgroundColor: '#FFFFFF',
				border: '1px solid #D6D7DA',
				borderRadius: '20px',
				padding: '30px',
			}}
		>
			<Stack gap="24px">
				<Typography fontSize="20px" fontWeight={700} color="#0B74E2">
					{title}
				</Typography>

				<Box display="flex" flexWrap="wrap" gap="8px">
					{tags.map((tag) => (
						<Chip
							key={tag.region}
							label={
								<>
									<Box component="span" sx={{ fontWeight: 700 }}>
										{`${tag.region} `}
									</Box>
									<Box component="span">{tag.details}</Box>
								</>
							}
							sx={{
								height: 'auto',
								backgroundColor: '#F1F8FF',
								borderRadius: '16px',
								fontSize: '16px',
								color: '#0B74E2',
								padding: '4px 16px',

								'& .MuiChip-label': { padding: 0, whiteSpace: 'normal' },
							}}
						/>
					))}
				</Box>
			</Stack>

			<Box
				sx={{
					'& img': {
						width: '100%',
						height: 'auto',
					},
				}}
			>
				<Image src={map} alt="" width={0} height={0} />
			</Box>
		</Stack>
	);
};

export default Section3Card;
